import { ReportsModule } from './reports/reports.module';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './_modules/auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { StudentModule } from '@student/student.module';
import { TeacherModule } from '@teacher/teacher.module';
import { ProfileModule } from '@profile/profile.module';
import { ResultsModule } from '@results/results.module';
import { AwardModule } from './shared/components/award/award.module';
import { NgxBootstrapModule } from '@app/ngx-bootstrap/ngx-bootstrap.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { AuthService } from '@app/_modules/auth/services/auth.service';
import { CustomUrlSerializer } from '@app/_modules/auth/services/url-serializer';

import {
    PopupService,
    PrivilegeService,
    FileService,
    AbsentService,
    TemplateService,
    HabirintService,
    PrepareBoxService,
    TaskService,
    StateService,
    ExExerciseService,
    ExerciseService,
    QuestionService,
    CountingService,
    PeopleService,
    MarketService,
    AccountService,
    NotificationsService,
    AppConfigsService,
    EventsService
} from '@app/core/services';

import { APIService } from '@app/_services/api.service';
import { AccessService } from '@app/_services/access.service';
import { HandlerService } from '@app/_services/handler.service';
import { AchievementsService } from '@results/services/achievements.service';
import { MainAnalyticsService } from '@profile/services/main_analytics.service';

import { ExerciseFormatPipe } from '@pipes/exercise-format.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { UrlSerializer } from '@angular/router';

registerLocaleData(localeRu, 'ru');

@NgModule({
    // объявляем компоненты, которые содержит наш модуль
    declarations: [AppComponent],
    // импортируем необходимые модули для работы данного модуля
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AuthModule,
        CoreModule,
        StudentModule,
        TeacherModule,
        ProfileModule,
        AwardModule,
        ResultsModule,
        ReportsModule,
        SharedModule.forRoot(),
        NgxBootstrapModule,
        GoogleChartsModule.forRoot()
    ],
    // Когда мы добавили сервисы, пайпы в провайдеры в корневой модуль AppModule,
    // они будут доступны в тех модулях которые подключены к даннгому модулю.
    providers: [
        EventsService,
        ExerciseFormatPipe,
        AuthService,
        PopupService,
        PrivilegeService,
        FileService,
        AbsentService,
        TemplateService,
        HabirintService,
        PrepareBoxService,
        TaskService,
        StateService,
        ExExerciseService,
        ExerciseService,
        QuestionService,
        CountingService,
        APIService,
        AccessService,
        HandlerService,
        PeopleService,
        AchievementsService,
        MarketService,
        AccountService,
        MainAnalyticsService,
        NotificationsService,
        AppConfigsService,
        { provide: UrlSerializer, useClass: CustomUrlSerializer },
        { provide: LOCALE_ID, useValue: 'ru' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
